
export const statusStyleArray = [

  {
    status: "archived",
    backgroundColor: "#c41d7f",
  },
  {
    status: "awaiting-review",
    backgroundColor: "#d4b106",
  },
  {
    status: "approved-by-contractor",
    backgroundColor: "#d46b08",
  },
  {
    status: "rejected-by-contractor",
    backgroundColor: "rgb(229, 71, 70)",
  },
  {
    status: "proposed-to-client",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "awaiting-review",
    backgroundColor: "#c292fd",
  },

  {
    status: "proposal",
    backgroundColor: "#096dd9",
  },
];
